'use strict';

require('es6-promise').polyfill();
require('url-polyfill');
require("formdata-polyfill");
require('es6-object-assign/auto');

import './arrayFind'
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

